function cov_tfkhrkuzy() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Sliders.tsx";
  var hash = "3244c4092466a41dea91c04832300321ecbc023c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Sliders.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 47
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3244c4092466a41dea91c04832300321ecbc023c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_tfkhrkuzy = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_tfkhrkuzy();
var Icon = (cov_tfkhrkuzy().s[0]++, {
  name: 'sliders',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.99908 7.25H3C2.30964 7.25 1.75 6.69036 1.75 6C1.75 5.30964 2.30964 4.75 3 4.75H3.99908C4.48886 3.57552 5.64803 2.75 7 2.75C8.35197 2.75 9.51114 3.57552 10.0009 4.75H21C21.6904 4.75 22.25 5.30964 22.25 6C22.25 6.69036 21.6904 7.25 21 7.25L10.0009 7.25C9.51114 8.42448 8.35197 9.25 7 9.25C5.64803 9.25 4.48886 8.42448 3.99908 7.25ZM6.25 6C6.25 5.58579 6.58579 5.25 7 5.25C7.41421 5.25 7.75 5.58579 7.75 6C7.75 6.41421 7.41421 6.75 7 6.75C6.58579 6.75 6.25 6.41421 6.25 6Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 19.5H10.0009C9.51114 20.6745 8.35198 21.5 7 21.5C5.64803 21.5 4.48886 20.6745 3.99908 19.5H3C2.30964 19.5 1.75 18.9404 1.75 18.25C1.75 17.5596 2.30964 17 3 17H3.99908C4.48886 15.8255 5.64803 15 7 15C8.35198 15 9.51114 15.8255 10.0009 17H21C21.6904 17 22.25 17.5596 22.25 18.25C22.25 18.9404 21.6904 19.5 21 19.5ZM7 17.5C6.58579 17.5 6.25 17.8358 6.25 18.25C6.25 18.6642 6.58579 19 7 19C7.41421 19 7.75 18.6642 7.75 18.25C7.75 17.8358 7.41421 17.5 7 17.5Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.2491 13.5C13.7389 14.6745 14.898 15.5 16.25 15.5C17.602 15.5 18.7611 14.6745 19.2509 13.5H21.25C21.9404 13.5 22.5 12.9404 22.5 12.25C22.5 11.5596 21.9404 11 21.25 11H19.2509C18.7611 9.82552 17.602 9 16.25 9C14.898 9 13.7389 9.82552 13.2491 11L3.25 11C2.55964 11 2 11.5596 2 12.25C2 12.9404 2.55964 13.5 3.25 13.5L13.2491 13.5ZM15.5 12.25C15.5 11.8358 15.8358 11.5 16.25 11.5C16.6642 11.5 17 11.8358 17 12.25C17 12.6642 16.6642 13 16.25 13C15.8358 13 15.5 12.6642 15.5 12.25Z\" fill=\"currentColor\"/>"
});
export default Icon;